<template>
    <div>
        <div class="header mt-5 mb-7">
            {{ $vuetify.lang.t('$vuetify.deviceManagement.deviceManagement') }}
        </div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input mb-3">
                    <v-text-field
                        class="locale-font"
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.deviceManagement.searchByBureau')"
                        solo dense hide-details
                        height="40px"
                        @keyup.enter="searchDevice()">
                    </v-text-field>
                    <v-btn
                        class="ml-3"
                        height="40"
                        color="primary"
                        outlined
                        @click="searchDevice()">
                        {{ $vuetify.lang.t('$vuetify.deviceManagement.search') }}
                    </v-btn>
                </div>

                <div class="filter-input">
                    <div class="status-filter">
                        <v-select
                            class="locale-font"
                            @change="getDevicesManagement()"
                            v-model="organization"
                            :items="organizationItems"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            height="40"
                            background-color="#ffffff">
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="total"
                :items="devicesManagements"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <i
                            class="far fa-edit"
                            @click.stop="assignDevices(item)">
                        </i>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <assign-device-modal
            ref="assignDeviceModal"
            :bureauId="bureau.id"
            :bureauName="bureau.name"
            @assigned="assignedDevices"
        />
    </div>
</template>

<script>
import AssignDeviceModal from '@/components/DeviceManagement/AssignDeviceModal.vue'
export default {
    name: 'DevicesManagement',

    components: {
        AssignDeviceModal
    },

    data () {
        return {
            search: null,
            pageCount: 1,
            page: 1,
            options: {},
            total: 0,
            organizationItems: [],
            organization: null,
            loading: false,
            devicesManagements: [],
            bureau: {},
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.deviceManagement.bureau'), value: 'name', width: '25%' },
                { text: this.$vuetify.lang.t('$vuetify.deviceManagement.acronym'), value: 'short_name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.deviceManagement.organization'), value: 'parent_name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.deviceManagement.locationAccess'), value: 'device_count', width: '15%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.deviceManagement.totalEmployee'), value: 'total_employee', width: '15%' },
                { text: '', value: 'action', width: '5%', sortable: false }
            ]
        }
    },

    methods: {
        async searchDevice () {
            this.options.page = 1
            await this.getDevicesManagement()
        },

        async getOrgOption () {
            const res = await this.axios.get('device-management/options')
            if (res && res.data && res.data.status === 'ok') {
                this.organizationItems = res.data.data
            }
        },

        async getDevicesManagement () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `device-managements?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.organization) {
                url += `&organization=${this.organization}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.devicesManagements = res.data.data
                this.total = res.data.total
                this.loading = false
            }
        },

        assignDevices (data) {
            this.bureau = data
            this.$refs.assignDeviceModal.dialog = true
        },

        async assignedDevices (bureau) {
            await this.getDevicesManagement()
            this.$notify({
                title: `${this.$vuetify.lang.t('$vuetify.assignDeviceModal.update')} "${bureau}"`,
                text: this.$vuetify.lang.t('$vuetify.assignDeviceModal.locationSuccessfully'),
                type: 'notify-success'
            })
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.DEVICE_MANAGEMENT.UPDATE)
        await this.getOrgOption()
    },

    watch: {
        options: {
            async handler () {
                await this.getDevicesManagement()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getOrgOption()
                await this.getDevicesManagement()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }

    ::v-deep .status-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
}
</style>
